/* eslint-disable import/first */
import '@atlaskit/css-reset'; // eslint-disable-line

// Polyfills
import './polyfills';

// React
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// App
import './fonts/fonts.css';
import './reset.css';
import './intercom';
import App from './App';
import store from './store';
import migration from './migration';
import sentry from './sentry';
import { initUfo } from 'modules/telemetry/initUFO';
import {
  CHECKOUT_CONTACTS_SUBMIT_UFO_NAME,
  UPGRADE_SUBMIT_CHANGELIST_UFO_NAME,
  CART_SUBMIT_STRIPE_UFO_NAME,
  CART_SUBMIT_CONVERT_TO_QUOTE_UFO_NAME,
  CART_SUBMIT_PAY_ON_TERMS_UFO_NAME,
  CART_SUBMIT_PAY_ON_ACCOUNT_UFO_NAME,
  CART_SUBMIT_PAYPAL_UFO_NAME,
  CART_SUBMIT_FREE_UFO_NAME,
  ITEMS_ADD_UFO_NAME,
  ORDER_LOOKUP_SUBMIT_UFO_NAME,
  LICENSE_DETAILS_UFO_NAME,
  ORDER_INVOICE_ACTION_PDF_UFO_NAME,
  LICENSE_TRACKED_ELSEWHERE_FETCH_UFO_NAME,
  LICENSE_IS_SITE_ON_CONCESSION_FETCH_UFO_NAME,
  LICENSE_IS_RENEWABLE_ACCOUNT_FETCH_UFO_NAME,
  LICENSE_IS_UPGRADABLE_ACCOUNT_FETCH_UFO_NAME,
  LICENSE_IS_ON_BEHALF_OF_EMAIL_FETCH_UFO_NAME,
  LICENSE_IS_HOSTED_ACCOUNT_PROVISIONING_FETCH_UFO_NAME,
} from 'util/ufoNameConstants';

sentry();
initUfo({
  product: 'cart',
  region: 'unknown',
  doNotAbortActivePressInteractionOnTransition: [
    CHECKOUT_CONTACTS_SUBMIT_UFO_NAME,
    UPGRADE_SUBMIT_CHANGELIST_UFO_NAME,
    CART_SUBMIT_STRIPE_UFO_NAME,
    CART_SUBMIT_CONVERT_TO_QUOTE_UFO_NAME,
    CART_SUBMIT_PAY_ON_TERMS_UFO_NAME,
    CART_SUBMIT_PAY_ON_ACCOUNT_UFO_NAME,
    CART_SUBMIT_PAYPAL_UFO_NAME,
    CART_SUBMIT_FREE_UFO_NAME,
    ITEMS_ADD_UFO_NAME,
    ORDER_LOOKUP_SUBMIT_UFO_NAME,
    LICENSE_DETAILS_UFO_NAME,
    ORDER_INVOICE_ACTION_PDF_UFO_NAME,
    LICENSE_TRACKED_ELSEWHERE_FETCH_UFO_NAME,
    LICENSE_IS_SITE_ON_CONCESSION_FETCH_UFO_NAME,
    LICENSE_IS_RENEWABLE_ACCOUNT_FETCH_UFO_NAME,
    LICENSE_IS_UPGRADABLE_ACCOUNT_FETCH_UFO_NAME,
    LICENSE_IS_ON_BEHALF_OF_EMAIL_FETCH_UFO_NAME,
    LICENSE_IS_HOSTED_ACCOUNT_PROVISIONING_FETCH_UFO_NAME,
  ],
  kind: {
    hover: 0,
    page_load: 1,
    press: 1,
    transition: 1,
    typing: 0,
  },
  rates: {
    unknown: 0,
  },
});

const root = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  root,
);

migration();
